import React from 'react';
import styled, { css } from 'styled-components';
import PillSelectBox from '../PillSelectBox';
import { StatusTooltip } from '../TooltipModals';

const Container = styled.div`
  width: 70px;
  display: inline-block;

  & > label {
    color: #797979;
    letter-spacing: -0.2px;
  }

  ${props => {
    if (props.variant === 'OptionsField') {
      return css`
        width: 77px;
        //margin-right: 10px;

        & > label {
          display: inline-block;
          padding-bottom: 20px;
        }
      `;
    }
  }}
`;

function StatusSelect(props) {
  return (
    <Container variant={props.variant}>
      <label
        htmlFor={props.id}
        style={{ display: props.hideLabel ? 'none' : '' }}
      >
        Status
      </label>
      {props.hideLabel ? null : <StatusTooltip />}
      <PillSelectBox
        id={props.id}
        value={props.value === '' ? 'draft' : props.value}
        variant={props.variant}
        onChange={e => props.onChange(e)}
      >
        <option className="select-box__option" value="draft">
          Draft
        </option>
        <option className="select-box__option" value="live">
          Live
        </option>
      </PillSelectBox>
    </Container>
  );
}

export default StatusSelect;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/StatusSelect/index.jsx